var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.33398 13.0052C1.33398 12.1212 1.68517 11.2733 2.31029 10.6482C2.93542 10.0231 3.78326 9.67188 4.66732 9.67188H11.334C12.218 9.67188 13.0659 10.0231 13.691 10.6482C14.3161 11.2733 14.6673 12.1212 14.6673 13.0052C14.6673 13.4472 14.4917 13.8712 14.1792 14.1837C13.8666 14.4963 13.4427 14.6719 13.0006 14.6719H3.00065C2.55862 14.6719 2.1347 14.4963 1.82214 14.1837C1.50958 13.8712 1.33398 13.4472 1.33398 13.0052Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 6.33594C9.38071 6.33594 10.5 5.21665 10.5 3.83594C10.5 2.45523 9.38071 1.33594 8 1.33594C6.61929 1.33594 5.5 2.45523 5.5 3.83594C5.5 5.21665 6.61929 6.33594 8 6.33594Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.25c7d11305f50f1c1a2245d1c6b6b090.svg";
export { ForwardRef as ReactComponent };